export default __webpack_public_path__ + "static/media/ukFlag.70e4e37f.svg";